import { AxiosResponse } from 'axios'

import { blurEffectForm } from 'src/utils/request'
import { IPropUpdateInfoUserSubscribe } from './api.dto'
import { IPropUpdateInfoUser } from 'types/form'
import { FormikValues } from 'formik/dist/types'

export const subscribe = ({ email }: IPropUpdateInfoUserSubscribe) => {
    return blurEffectForm.post('/suscribe', {
        email,
    })
}
export const contactUs = ({
    name,
    email,
    message,
    service_of_interest,
    terms_and_conditions,
    continue_receiving_information,
}: IPropUpdateInfoUser) => {
    return blurEffectForm.post<
        IPropUpdateInfoUser,
        AxiosResponse<IPropUpdateInfoUser>,
        IPropUpdateInfoUser
    >('/contact-us', {
        name,
        email,
        service_of_interest,
        message,
        terms_and_conditions,
        continue_receiving_information,
        landing: true,
    })
}
export const workWith = (values: FormikValues) => {
    return blurEffectForm.post('/work-with-us', { ...values })
}
export const loadResume = async (dataResume: File) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const { name, type, size } = dataResume
        const res = await blurEffectForm.post('/upload-cv', {
            name,
            type,
            size,
            path: 'curriculum_name',
        })

        await fetch(res.data.url, {
            method: 'PUT',
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            body: dataResume,
        })
        return res
    } catch (error) {
        throw error
    }
}
